import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Button, ButtonVariant as IntelligenceButtonVariant, } from "../Button/Button";
export var OutlinedButton = function (_a) {
    var buttonText = _a.buttonText, icon = _a.icon, onClick = _a.onClick, disabled = _a.disabled, loading = _a.loading, dataHsId = _a["data-hs-id"];
    return (_jsx(Button, { variant: IntelligenceButtonVariant.Secondary, text: buttonText, disabled: disabled || false, iconPath: icon, loading: loading, onClick: onClick, "data-hs-id": dataHsId }));
};
